var alternativeHotels = vueIfExists({
	mixins: [win.displayPrice, win.hotelListItem],
	el: '#alternative-hotels',
	mounted: function() {
		this.currencyDecimals = 0;
	},
	data: {
		hotels: [],
		city: "",
		totalInCity: 0,
		sharedState: store.state
	},
	methods: {
		setData: function(data) {
			if (data) {
				this.hotels = data.hotels;
				this.city = data.city;
				this.totalInCity = data.totalInCity;
			} else {
				this.hotels = [];
				this.city = "";
				this.totalInCity = 0;
			}
		}
	}
});